import {
	Button,
	Card,
	Col,
	Form,
	Input,
	Row,
	Select,
	Typography,
	Radio,
	Spin,
	message,
} from "antd";
import { toast } from "react-toastify";

import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useLocation, Navigate } from "react-router-dom";
import { loadAllProductCategory } from "../../redux/actions/productCategory/getProductCategoryAction";
import { loadAllProductSubCategory } from "../../redux/actions/productSubCategory/getProductSubCategory";
import { loadAllCustomer } from "../../redux/actions/customer/getCustomerAction";
import axios from "axios";
import styles from "./AddProd.module.css";
import LayerSelectorBasic from "../Card/LayerSelectorBasic";
import LayerSelectorAdvance from "../Card/LayerSelectorAdvance";
import LayerTemplateSelector from "../Card/LayerTemplateSelector";
import PrintSelector from "../Card/PrintSelector";
import CoatingSelector from "../Card/CoatingSelector";
import PageTitle from "../page-header/PageHeader";
import data from "../../data/rawMaterialData";
import { buildLayersForPly } from "../../utils/layerUtils";

const UpdateRunningSize = () => {
	const { unitType, ply: plyOptions, castingType } = data;
	const { id } = useParams();
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const layerObj = { layerId: 0, layerType: "", materialType: "", gsm: "", bf: "", ff: "" };

	const subCategory = useSelector((state) => state.productSubCategories?.list);
	const customer = useSelector((state) => state.customers?.list);

	const { Title } = Typography;
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(true);
	const [loader, setLoader] = useState(false);
	const [isPrinting, setIsPrinting] = useState(false);
	const [isCoating, setIsCoating] = useState(false);
	const [layers, setLayers] = useState([]);
	const [layerSelector, setLayerSelector] = useState(false);
	const [gsm, setGsm] = useState([]);
	const [bf, setBf] = useState([]);
	const [printing, setPrinting] = useState({});
	const [coating, setCoating] = useState({ coatings: [] });
	const [rateType, setRateType] = useState('individual');

	useEffect(() => {
		dispatch(loadAllProductSubCategory({ page: 1, limit: 100 }));
		dispatch(loadAllCustomer({ page: 1, limit: 100 }));
	}, [dispatch]);

	// Load existing running size data
	useEffect(() => {
		const loadData = async () => {
			try {
				let rs;
				if (location.state?.data) {
					rs = location.state.data;
				} else {
					const resp = await axios.get(`running-size/${id}`);
					rs = resp.data;
				}

				// Parse layers
				let parsedLayers = [];
				try {
					parsedLayers = typeof rs.layers === "string" ? JSON.parse(rs.layers) : rs.layers || [];
				} catch (e) {
					parsedLayers = [];
				}

				// Parse printing
				let parsedPrinting = {};
				try {
					parsedPrinting = typeof rs.printing === "string" ? JSON.parse(rs.printing) : rs.printing || {};
				} catch (e) {
					parsedPrinting = {};
				}

				// Parse coating
				let parsedCoating = { coatings: [] };
				try {
					parsedCoating = typeof rs.coating === "string" ? JSON.parse(rs.coating) : rs.coating || { coatings: [] };
				} catch (e) {
					parsedCoating = { coatings: [] };
				}

				setLayers(parsedLayers);
				setIsPrinting(rs.is_printing || false);
				setIsCoating(rs.is_coating || false);
				setPrinting(parsedPrinting);
				setCoating(parsedCoating);
				setLayerSelector(rs.layer_selector || false);

				// Set up gsm/bf arrays for layer selector — pre-populate from existing material types
				const gsmArr = parsedLayers.map((l) =>
					l.materialType && data.materialGsm[l.materialType] ? data.materialGsm[l.materialType] : []
				);
				const bfArr = parsedLayers.map((l) =>
					l.materialType && data.materialBf[l.materialType] ? data.materialBf[l.materialType] : []
				);
				setGsm(gsmArr);
				setBf(bfArr);

				// Build BASIC layer selector form field values
				const layerFields = {};
				if (parsedLayers[0]) {
					layerFields.materialType = parsedLayers[0].materialType;
					layerFields.top_gsm = parsedLayers[0].gsm;
					layerFields['top-bf'] = parsedLayers[0].bf;
				}
				if (parsedLayers[1]) {
					layerFields.flute_materialType = parsedLayers[1].materialType;
					layerFields.flute_gsm = parsedLayers[1].gsm;
					layerFields.flute_bf = parsedLayers[1].bf;
					layerFields.flute_ff = parsedLayers[1].ff;
				}
				if (parsedLayers[2]) {
					layerFields.face_materialType = parsedLayers[2].materialType;
					layerFields.face_gsm = parsedLayers[2].gsm;
					layerFields.face_bf = parsedLayers[2].bf;
				}

				// Build ADVANCE layer selector form field values (dynamic per-layer)
				parsedLayers.forEach((layer, i) => {
					if (layer.materialType) layerFields[`materialType-${i}`] = layer.materialType;
					if (layer.gsm) layerFields[`materialGsm-${i}`] = layer.gsm;
					if (layer.bf) layerFields[`materialBf-${i}`] = layer.bf;
					if (layer.ff) layerFields[`materialFf-${i}`] = layer.ff;
				});

				// Build printing form field values
				const printFields = {};
				if (parsedPrinting.printingType) printFields.printing_type = parsedPrinting.printingType;
				if (parsedPrinting.printingColors) printFields.printing_colors = parsedPrinting.printingColors;
				if (parsedPrinting.printingSides) printFields.printing_sides = parsedPrinting.printingSides;
				if (parsedPrinting.printingSpecialColors) printFields.printing_special_colors = parsedPrinting.printingSpecialColors;

				// Build coating form field values
				const coatFields = {};
				if (parsedCoating.coatings && parsedCoating.coatings.length > 0) {
					coatFields.coating_type = parsedCoating.coatings;
				}

				form.setFieldsValue({
					name: rs.name,
					subcategory: rs.product_sub_category_id,
					customer: rs.customer_id,
					length: rs.length,
					width: rs.width,
					height: rs.height,
					unitType: rs.unit_type,
					casting: rs.casting_type,
					quantity: rs.avg_order_quantity,
					lastSalePrice: rs.last_sale_price,
					ply: rs.ply,
					layerSelector: rs.layer_selector ? "advance" : "basic",
					print_selector: rs.is_printing ? "yes" : "no",
					isCoating: rs.is_coating ? "yes" : "no",
					topConversionRate: rs.top_conversion_rate,
					boxConversionRate: rs.box_conversion_rate,
					rs: rs.rs,
					cs: rs.cs,
					boxesPerSheet: rs.boxes_per_sheet,
					sheetsPerBox: rs.sheets_per_box,
					remarks: rs.remarks || '',
					boxType: rs.box_type || undefined,
					rateType: rs.rate_type || 'individual',
					packingQuantity: rs.packing_quantity || undefined,
					joiningMethod: rs.joining_method || undefined,
					...layerFields,
					...printFields,
					...coatFields,
				});
				// Set rateType state for conditional rendering
				setRateType(rs.rate_type || 'individual');
			} catch (error) {
				toast.error("Failed to load running size data");
				console.log(error.message);
			} finally {
				setLoading(false);
			}
		};
		loadData();
	}, [id, location.state, form]);

	const onFinish = async (values) => {
		setLoader(true);
		try {
			const payload = {
				name: values.name,
				subcategory: values.subcategory,
				customer: values.customer,
				length: values.length,
				width: values.width,
				height: values.height,
				unitType: values.unitType,
				casting: values.casting,
				quantity: values.quantity,
				lastSalePrice: values.lastSalePrice,
				ply: values.ply,
				layerSelector: layerSelector,
				layers: JSON.stringify(layers),
				isPrinting: isPrinting,
				printing: JSON.stringify(printing),
				isCoating: isCoating,
				coating: JSON.stringify(coating),
			};
			if (values.topConversionRate) payload.topConversionRate = values.topConversionRate;
			if (values.boxConversionRate) payload.boxConversionRate = values.boxConversionRate;
			payload.rs = values.rs || null;
			payload.cs = values.cs || null;
			payload.boxesPerSheet = values.boxesPerSheet || null;
			payload.sheetsPerBox = values.sheetsPerBox || null;
			payload.remarks = values.remarks || '';
			payload.boxType = values.boxType || null;
			payload.rateType = values.rateType || 'individual';
			payload.packingQuantity = (values.rateType && values.rateType !== 'individual' && values.packingQuantity) ? values.packingQuantity : null;
			payload.joiningMethod = values.joiningMethod || null;

			await axios.put(`running-size/${id}`, payload);
			toast.success("Running size updated successfully");
			navigate(`/product/${id}`);
		} catch (error) {
			toast.error(`Failed to update: ${error.response?.data || error.message}`);
		} finally {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		setLoader(false);
		const firstError = errorInfo?.errorFields?.[0]?.errors?.[0] || "Please fill all required fields";
		toast.error(firstError);
	};

	const handlePrintingChange = (e) => {
		if (e.target.value === "yes") {
			setIsPrinting(true);
		} else {
			setIsPrinting(false);
			setPrinting({});
		}
	};

	const handleCoatingChange = (e) => {
		if (e.target.value === "yes") {
			setIsCoating(true);
		} else {
			setIsCoating(false);
			setCoating({ coatings: [] });
		}
	};

	const handlePlyChange = (ply) => {
		const { layersArray, gsmArray, bfArray } = buildLayersForPly(ply, layers, layerObj);
		setLayers(layersArray);
		setGsm(gsmArray);
		setBf(bfArray);
	};

	const handleSelectorChange = (e) => {
		if (e.target.value === "advance") {
			setLayerSelector(true);
		} else {
			setLayerSelector(false);
		}
	};

	const isLogged = Boolean(localStorage.getItem("isLogged"));
	if (!isLogged) {
		return <Navigate to={"/auth/login"} replace={true} />;
	}

	if (loading) {
		return (
			<div style={{ textAlign: "center", padding: 50 }}>
				<Spin size="large" />
			</div>
		);
	}

	return (
		<>
			<PageTitle title="Back" />
			<Fragment>
				<Row className="mr-top" justify="space-between" gutter={[0, 30]}>
					<Col xs={24} sm={24} md={24} lg={24} xl={24} className="rounded column-design">
						<Form
							form={form}
							name="basic"
							labelCol={{ span: 7 }}
							labelWrap
							wrapperCol={{ span: 16 }}
							initialValues={{
								layerSelector: "basic",
								print_selector: "no",
								isCoating: "no",
							}}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete="off"
						>
							<Row className="mr-top" justify="space-evenly" gutter={[0, 30]}>
								<Col xs={24} sm={24} md={24} lg={8} xl={8} className="rounded column-design">
									<Card bordered={false}>
										<Title level={4} className="m-2 text-center">
											Edit Running Size — Sizing
										</Title>

										<Form.Item style={{ marginBottom: "15px" }} label="Name" name="name" rules={[{ required: true, message: "Please input name!" }]}>
											<Input />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} name="subcategory" label="Subcategory" rules={[{ required: true, message: "Please select sub-category!" }]}>
											<Select loading={!subCategory} showSearch placeholder="Select Subcategory" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
												{subCategory && subCategory.map((subcat) => (
													<Select.Option key={subcat.id} value={subcat.id}>{subcat.name}</Select.Option>
												))}
											</Select>
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} name="customer" label="Customer" rules={[{ required: true, message: "Please select customer!" }]}>
											<Select loading={!customer} showSearch placeholder="Select Customer" optionFilterProp="children" filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}>
												{customer && customer.map((cust) => (
													<Select.Option key={cust.id} value={cust.id}>{cust.name}</Select.Option>
												))}
											</Select>
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Length" name="length" rules={[{ required: true, message: "Please input length!" }]}>
											<Input type="number" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Width" name="width" rules={[{ required: true, message: "Please input width!" }]}>
											<Input type="number" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Height" name="height" rules={[{ required: true, message: "Please input height!" }]}>
											<Input type="number" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} name="unitType" label="Unit" rules={[{ required: true, message: "Please select unit type!" }]}>
											<Select showSearch placeholder="Unit" optionFilterProp="children" filterOption={(input, option) => option.children.includes(input)}>
												{unitType && unitType.map((unit) => (
													<Select.Option key={unit} value={unit}>{unit}</Select.Option>
												))}
											</Select>
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} name="casting" label="Casting" rules={[{ required: true, message: "Please select casting!" }]}>
											<Select showSearch placeholder="Casting" optionFilterProp="children" filterOption={(input, option) => option?.children.includes(input)}>
												{castingType && castingType.map((casting, i) => (
													<Select.Option key={i + 1} value={casting.value}>{casting.name}</Select.Option>
												))}
											</Select>
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Quantity" name="quantity" rules={[{ required: true, message: "Please input Quantity!" }]}>
											<Input type="number" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Sale Price" name="lastSalePrice" rules={[{ required: true, message: "Please input Sale Price!" }]}>
											<Input type="number" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Top Conversion Rate /Kg" name="topConversionRate">
											<Input type="number" placeholder="Optional" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Box Conversion Rate /Kg" name="boxConversionRate">
											<Input type="number" placeholder="Optional" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="RS" name="rs">
											<Input type="number" placeholder="Optional" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="CS" name="cs">
											<Input type="number" placeholder="Optional" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Boxes per Sheet (m)" name="boxesPerSheet">
											<Input type="number" min={1} placeholder="Optional" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Sheets per Box (n)" name="sheetsPerBox">
											<Input type="number" min={1} placeholder="Optional" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} label="Remarks" name="remarks">
											<Input.TextArea rows={2} placeholder="Optional remarks" />
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} name="boxType" label="Box Type">
											<Select placeholder="Select Box Type" allowClear>
												<Select.Option value="inner">Inner</Select.Option>
												<Select.Option value="outer">Outer</Select.Option>
											</Select>
										</Form.Item>

										<Form.Item style={{ marginBottom: "15px" }} name="rateType" label="Rate Type">
											<Select placeholder="Select Rate Type" onChange={(val) => setRateType(val)}>
												<Select.Option value="individual">Individual</Select.Option>
												<Select.Option value="innerwise">Innerwise</Select.Option>
												<Select.Option value="outerwise">Outerwise</Select.Option>
											</Select>
										</Form.Item>

										{rateType && rateType !== 'individual' && (
											<Form.Item
												style={{ marginBottom: "15px" }}
												label="No. of Inners"
												name="packingQuantity"
												rules={[{ required: true, message: 'Please input no. of inners!' }]}
											>
												<Input type="number" min={1} placeholder="No. of inners per outer" />
											</Form.Item>
										)}

										<Form.Item style={{ marginBottom: "15px" }} name="joiningMethod" label="Glueing">
											<Radio.Group buttonStyle="solid">
												<Radio.Button value="stitching">Stitching</Radio.Button>
												<Radio.Button value="hand_pasting">Hand Pasting</Radio.Button>
											</Radio.Group>
										</Form.Item>
									</Card>
								</Col>

								<Col xs={24} sm={24} md={24} lg={16} xl={16} className="rounded column-design">
									<Card bordered={false}>
										<Title level={4} className="m-2 text-center">
											Customization
										</Title>

										<Form.Item style={{ marginBottom: "15px" }} name="ply" label="Ply/ Walls" rules={[{ required: true, message: "Please select plys!" }]}>
											<Select showSearch placeholder="Ply/ Walls" optionFilterProp="children" filterOption={(input, option) => option.children.includes(input)} onChange={handlePlyChange}>
												{plyOptions && plyOptions.map((p) => (
													<Select.Option key={p.value} value={p.value}>{p.name}</Select.Option>
												))}
											</Select>
										</Form.Item>

										<Form.Item rules={[{ required: true, message: "Please Select Type!" }]} label="Layer Selector" name="layerSelector" style={{ marginBottom: "15px" }}>
											<Radio.Group onChange={handleSelectorChange}>
												<Radio value="basic">Basic</Radio>
												<Radio value="advance">Advance</Radio>
											</Radio.Group>
										</Form.Item>

									<LayerTemplateSelector
										ply={layers.length}
										layers={layers}
										setLayers={setLayers}
										gsm={gsm}
										setGsm={setGsm}
										bf={bf}
										setBf={setBf}
									/>

										<Form.Item label="Printing" name="print_selector" style={{ marginBottom: "15px" }}>
											<Radio.Group onChange={handlePrintingChange}>
												<Radio value="yes">Yes</Radio>
												<Radio value="no">No</Radio>
											</Radio.Group>
										</Form.Item>

										{isPrinting ? <PrintSelector printing={printing} setPrinting={setPrinting} isPrinting={isPrinting} /> : <></>}

										<Form.Item label="Coating" name="isCoating" style={{ marginBottom: "15px" }}>
											<Radio.Group onChange={handleCoatingChange}>
												<Radio value="yes">Yes</Radio>
												<Radio value="no">No</Radio>
											</Radio.Group>
										</Form.Item>

										{isCoating ? <CoatingSelector coating={coating} setCoating={setCoating} isCoating={isCoating} /> : <></>}

										<Form.Item style={{ marginBottom: "15px" }}>
										<Row gutter={12} justify="center">
											<Col xs={12} sm={8} md={6}>
												<Button type="primary" htmlType="submit" shape="round" loading={loader} block>
													Update
												</Button>
											</Col>
											<Col xs={12} sm={8} md={6}>
												<Button danger shape="round" onClick={() => navigate(-1)} block>
													Cancel
												</Button>
											</Col>
										</Row>
									</Form.Item>
									</Card>
								</Col>
							</Row>
						</Form>
					</Col>
				</Row>
			</Fragment>
		</>
	);
};

export default UpdateRunningSize;
